import React, {useState, useContext} from 'react';
import axios from 'axios';
import {AuthenticatedContext} from '../App';

const LoginPage = props => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const {setIsLoggedIn, isLoggedIn, setUserCreds} = useContext(AuthenticatedContext);

  const [message, setMessage] = useState('');

  const handleChange = e => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!formData.username || !formData.password) {
      setMessage('Please enter both username and password.');
      return;
    }

    try {
      const res = await axios.post(`${props.baseURL}/api/login`, formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (res.status === 200) {
        setMessage('Login successful! Go to a new page and start writing!');
        // You can add a redirect or token storage here
        // Update the context state to reflect the logged-in user
        setIsLoggedIn(true);
        setUserCreds(res.data.user); // Update user credentials from response (if necessary)

        // Optionally, you can redirect the user to another page after login
        // For example, redirect to the homepage or dashboard
        props.history.push('/'); // Use this if you're using react-router
      } else {
        setMessage(res.data.error || 'Login failed.');
      }
    } catch (err) {
      if (err.response) {
        setMessage(err.response.data.error || 'Login failed.');
      } else {
        setMessage('Error connecting to server.');
      }
    }
  };

  return (
    <div style={styles.container}>
      {isLoggedIn && isLoggedIn ? (
        <h2>You are logged in!</h2>
      ) : (
        <div>
          <h2>Log In</h2>
          <form onSubmit={handleSubmit} style={styles.form}>
            <input
              type="text"
              name="username"
              placeholder="Username"
              value={formData.username}
              onChange={handleChange}
              style={styles.input}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              style={styles.input}
            />
            <button type="submit" style={styles.button}>
              Log In
            </button>
          </form>
        </div>
      )}
      {message && <p>{message}</p>}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '40px auto',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '10px',
    fontFamily: 'sans-serif',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  input: {
    padding: '10px',
    fontSize: '16px',
  },
  button: {
    padding: '10px',
    backgroundColor: '#28a745',
    color: 'white',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default LoginPage;
